export const logos = [
    {
        id: 0,
        src: "/assets/images/mongodb-icon.svg",
        title: "MongoDB",
        href: "https://www.mongodb.com/"
    },
    {
        id: 1,
        src: "/assets/images/expressjs-icon.svg",
        title: "Express",
        href: "https://expressjs.com/"
    },
    {
        id: 2,
        src: "/assets/images/reactjs-icon.svg",
        title: "React",
        href: "https://reactjs.org/"
    },
    {
        id: 3,
        src: "/assets/images/nodejs-icon.svg",
        title: "NodeJS",
        href: "https://nodejs.org/"
    },
    {
        id: 4,
        src: "/assets/images/mui-icon.svg",
        title: "Material UI",
        href: "https://mui.com/"
    },
    {
        id: 5,
        src: "/assets/images/p5js-asterisk.svg",
        title: "p5",
        href: "https://p5js.org/"
    },
    {
        id: 6,
        src: "/assets/images/swal2-icon.svg",
        title: "SweetAlert2",
        href: "https://sweetalert2.github.io/"
    },
    {
        id: 7,
        src: "/assets/images/heroku-icon.svg",
        title: "Heroku",
        href: "https://www.heroku.com/"
    },
    {
        id: 8,
        src: "/assets/images/netlify-icon.svg",
        title: "Netlify",
        href: "https://www.netlify.com/"
    },
    {
        id: 9,
        src: "/assets/images/git-icon.svg",
        title: "Git",
        href: "https://git-scm.com/"
    },
    {
        id: 10,
        src: "/assets/images/github-icon.svg",
        title: "GitHub",
        href: "https://github.com/"
    }
]